module.exports = function(app) {
    app.directive('feedbackBar', function() {

        return {
            restrict: 'A',
            replace: true,
            template: require('directives/common/feedbackBar.html'),
            controller: [function() {

            }],
            link: function(scope, elem, attrs, controller) {
                // scope here is a mixin of all parent scopes
                // we use only one message div in the html template; the value is set w $scope
                // we set the color with the style classes failure, success, notification
                // we set the icon with a property on $scope/scope  feedback.success, feedback.notification, feedback.failure
                //   scope.feedback.showResetFeedback('the message', 'success')
                scope.feedback = (scope.feedback) ? scope.feedback : {};
                scope.feedback.showFeedback = function (theMsg, whichFeedback) {
                    showThis(elem[0], theMsg, whichFeedback);
                }
                scope.feedback.hideFeedback = function () {
                    hideThis(elem[0]);
                }

                var showThis = function(theSection, msg, msgStyleClass) {

                        theSection.classList.remove('hide-feedback')
                        theSection.classList.add('show-feedback')
                        // this sets the background color of the bar - a <div>
                        theSection.children[0].classList.remove('success');
                        theSection.children[0].classList.remove('failure');
                        theSection.children[0].classList.remove('notification');
                        theSection.children[0].classList.add(msgStyleClass);
                    // }


                    scope.feedback.success = scope.feedback.failure = scope.feedback.notification = false;
                    // this switch block controls which icon displays with the message
                    switch (msgStyleClass) {
                        case 'success':
                            scope.feedback.success = true;
                            break;
                        case 'failure':
                            scope.feedback.failure = true;
                            break;
                        case 'notification':
                            scope.feedback.notification = true;
                            break;
                        default:
                            scope.feedback.notification = true;
                            break;
                    }
                    scope.feedback.theFeedback = msg;
                    setTimeout(function() {
                        scope.$apply();
                    }, 100);


                }
                var hideThis = function(theSection) {
                    theSection.classList.remove('show-feedback');
                    theSection.classList.add('hide-feedback');
                }
            }
        };
    });
}
